<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">诊疗项目名称:</div>
                <el-input v-model="conditionData.name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">省市:</div>
                <el-cascader
                size="small"
                :options="options"
                v-model="conditionData.city"
                @change="handleRegionChange">
                </el-cascader>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="诊疗项目名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="province"
                label="省份"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="城市"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="JMratio"
                label="居民医保自付比例"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ZGratio"
                label="职工医保自付比例"
                align="center"
                >
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        
       <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { provinceAndCityData , CodeToText , TextToCode } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:44,
            conditionData:{
                petShop:'',
                page:1,
                pageSize:20,
            },
            addData:{},
            updateData:{
                petShop:'',
                contacts:'',
                phone:'',
                address:'',
                province:'',
                city:'',
                area:'',
                addressCode:'',
                projectPrices:[{
                    name: '',
                    price: '',
                }],
            },
            tableData:[],
            tableData1:[

               {
                name:'基层一般诊疗费-基层医疗卫生机构一般诊疗费',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'基层一般诊疗费-农村卫生站一般诊疗费',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'诊查费-专家门诊诊查费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'15%',
               },{
                name:'诊查费-急诊诊查费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'15%',
               },{
                name:'诊查费-门急诊留观诊查费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'15%',
               },{
                name:'诊查费-住院诊查费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'15%',
               },{
                name:'诊查费-网上就诊诊查费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'15%',
               }
               ,{
                name:'急诊监护费-急诊监护费',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'院前急救费-院前急救费',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'救护车费-救护车费',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },


               {
                name:'护理费-肛周护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'护理费-糖尿病足护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'抢救费-大抢救',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'抢救费-中抢救',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'抢救费-小抢救',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'氧气吸入-氧气吸入',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },
               {
                name:'注射-肌肉注射',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },
               {
                name:'注射-静脉注射',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },
               {
                name:'注射-心内注射',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },
               {
                name:'注射-动脉加压注射',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },
               
               
            ],

            tableData2:[ 
               {
                name:'床位费-普通病房床位费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },{
                name:'床位费-监护病房床位费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },{
                name:'床位费-门急诊观察床位费',
                province:'广东省',
                city:'广州市',
                JMratio:'30%',
                ZGratio:'10%',
               },{
                name:'会诊费-院际会诊',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'会诊费-院内会诊',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'会诊费-远程会诊',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-重症监护',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-特级监护',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-特殊疾病护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-新生儿护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },

               {
                name:'清创缝合-清创缝合(大)',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'清创缝合-清创缝合(中)',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'清创缝合-清创缝合(小)',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'清创缝合-超神清创术',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'雾化吸入-雾化吸入',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'胃肠减压-胃肠减压',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'洗胃-洗胃',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'物理降温-特殊物理降温',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'冷热湿敷-冷热湿敷',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
               {
                name:'引流管冲洗-引流管冲洗',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },
            ],

            tableData3:[ {
                name:'护理费-新生儿特殊护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-精神病护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-气管切开护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               },{
                name:'护理费-一般专项护理',
                province:'广东省',
                city:'广州市',
                JMratio:'20%',
                ZGratio:'10%',
               }






            ],

            addressList:[],
            options:provinceAndCityData,
            picList1:[],
            picList2:[],
            picList3:[],
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            list:[
                '化学药','生物制品','中成药','中药饮片'
            ],
        }
    },
    created(){
        

    },
    mounted(){
        this.tableData = this.tableData1;
        // this.loadingData();
    },
    methods:{
        handleRegionChange(){
            
           
        },
        async addImg1(file){
            let res = await api.uploadOther(file.file);
            this.picList1.push(res);
        },
        async addImg2(file){
            let res = await api.uploadOther(file.file);
            this.picList2.push(res);
        },
        async addImg3(file){
            let res = await api.uploadOther(file.file);
            this.picList3.push(res);

        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        previewImg(index,piclist){
            this.imgIndex = index
            this.showBigImgList = piclist;
            this.showBigImg = true;
        },
        clearImg(index,type){
            if(type==1){
                this.picList1.splice(index,1)
            }else if(type==2){
                this.picList2.splice(index,1)
            }else if(type==3){
                this.picList3.splice(index,1)
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.collectPetQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.tableData = this.tableData1;

            // this.loadingData();
        },
        reset(){
            this.conditionData = {
                // name:'',
                page:1,
                pageSize:10,
            };
            this.tableData = this.tableData1;

            // this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            // this.loadingData();
            if(page == 1){
                this.tableData = this.tableData1;
            }
            if(page == 2){
                this.tableData = this.tableData2;
            }
            if(page == 3){
                this.tableData = this.tableData3;
            }
        },
        showAddDialog(){
            this.title = '新增';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.CreateRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }

        },
        async deletePetShop(row){

            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePetShopFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


            
        },
        async deletePetShopFun(id){
            let res  = await api.collectPetDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        async updateshop(){
            for(let index in this.updateData.projectPrices){
                this.updateData.projectPrices[index].price = parseFloat(this.updateData.projectPrices[index].price?this.updateData.projectPrices[index].price:0)
            }
            this.updateData.shopLog = JSON.stringify(this.picList1);
            this.updateData.jyzz = JSON.stringify(this.picList2);
            this.updateData.jyxm = JSON.stringify(this.picList3);
            let res  = await api.collectPetUpdate(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
            this.addressList = this.updateData.addressCode.split(',');
            this.picList1 = JSON.parse(this.updateData.shopLog?this.updateData.shopLog:'[]')
            this.picList2 = JSON.parse(this.updateData.jyzz?this.updateData.jyzz:'[]')
            this.picList3 = JSON.parse(this.updateData.jyxm?this.updateData.jyxm:'[]')
        },
        deleteXM(index){
            this.updateData.projectPrices.splice(index);
        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.addressCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.area = CodeToText[codeArray[2]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[2]
            }
        },
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 11,
                "Condition":{
                    "petShop":this.conditionData.petShop,
                    "pageSize":10000,
                }
                
            },'宠物店资料收集');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 120px;
                margin-left: 15px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                width: 215px;
            }
            .label-pic{
                width: 600px;
                display: flex;
                align-items: center;
                span{
                    color: red;
                    font-size: 20px;
                    margin: 0 4px;
                    margin-top: 2px;
                }
            }
            .pics{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                .pics-item{
                    width: 120px;
                    height: 120px;
                    position: relative;
                    margin-right: 10px;
                    margin-left: 10px;
                    .pics-item-img{
                        width: 120px;
                        height: 120px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
                .chooseimg{
                    margin-right: 10px;
                    margin-left: 10px;
                }
                img{
                    width: 120px;
                    height: 120px;
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
